import { render, staticRenderFns } from "./companySelfTest.vue?vue&type=template&id=40fc36d9&scoped=true"
import script from "./companySelfTest.vue?vue&type=script&lang=js"
export * from "./companySelfTest.vue?vue&type=script&lang=js"
import style0 from "./companySelfTest.vue?vue&type=style&index=0&id=40fc36d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc36d9",
  null
  
)

export default component.exports